/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/list_email_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdListEmailSettings } from "./constants";
import type { ServerSideFromAddress, getEngagementListEmailSettingsParams } from "./types";

export const getEngagementListEmailSettings = reactQueryFetcherAdapter(
  engagementAppGroupIdListEmailSettings,
  (
    signal: AbortSignal,
    { appGroupId, listType, query = "" }: getEngagementListEmailSettingsParams
  ): Promise<ServerSideFromAddress[]> => {
    return fetch(
      `/engagement/${appGroupId}/list_email_settings`,
      "GET",
      { query, list_type: listType },
      { signal }
    );
  }
);
